export default function Footer() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-12 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-12 mb-16">
          <div className="space-y-6">
            <img 
              src="https://static.readdy.ai/image/04bffda83af79335128d062f8508dd8e/9ed829457d315ff9eeb999651e029ece.png" 
              alt="Hydrogen Technology" 
              className="h-20 w-auto"
            />
            <p className="text-gray-400 leading-relaxed">
              Leading the clean hydrogen revolution with innovative electrolysis technology
            </p>
          </div>

          <div>
            <h4 className="font-semibold text-lg mb-4">Company</h4>
            <ul className="space-y-3">
              <li>
                <button onClick={() => scrollToSection('about')} className="text-gray-400 hover:text-white transition-colors cursor-pointer">
                  About Us
                </button>
              </li>
              <li>
                <a href="/privacy-policy" className="text-gray-400 hover:text-white transition-colors cursor-pointer">
                  Privacy Policy
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-semibold text-lg mb-4">Solutions</h4>
            <ul className="space-y-3">
              <li>
                <button onClick={() => scrollToSection('technology')} className="text-gray-400 hover:text-white transition-colors cursor-pointer">
                  Technology
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('applications')} className="text-gray-400 hover:text-white transition-colors cursor-pointer">
                  Applications
                </button>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-8">
          <div className="flex flex-col md:flex-row justify-center items-center">
            <p className="text-gray-400 text-sm">
              © 2025 Hydville Systems Ltd. All rights reserved.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}
